import MobileSliderPagesWrapper from "../../components/MobileSliderPagesWrapper";
import SliderMobileModalHeader from "../../components/SliderMobileModalHeader";
import RequestFeedback from "../../../../../modules/RequestFeedback/RequestFeedback";
import appHistory from "../../../../../app/appHistory";
import { useCallback } from "react";
import { FormGroup } from "react-bootstrap";
import { useLocation } from "react-router";
import useSkipFeedback from '../../../../../modules/RequestFeedback/hooks/useSkipFeedback';

export default function SlideMobileRequestFeedback() {
    const { pathname, search } = useLocation();
    const handleSkipFeedback = useSkipFeedback(true);

    const onCloseHandler = useCallback(() => {
        handleSkipFeedback();
        const searchParams = new URLSearchParams(search);
        // @ts-ignore
        searchParams.delete('s', 'request-feedback');
        appHistory.replace(`${pathname}?${searchParams.toString()}`);
    }, [pathname, search, handleSkipFeedback]);

    return <MobileSliderPagesWrapper backgroundColor={'var(--color-background-secondary)'} style={{ padding: '16px' }}>
        <SliderMobileModalHeader onClickHandler={onCloseHandler}/>
        <FormGroup className={'mb-2'}>
            <RequestFeedback isPopup={true} onClose={onCloseHandler}/>
        </FormGroup>
    </MobileSliderPagesWrapper>
}
